import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { TopicService } from "../../topic-player/services/topic.service";
import { Observable } from "rxjs";
import { Subject } from "../../topic-player/interfaces/subject.interface";

@Injectable({
  providedIn: 'root'
})

export class SubjectResolver  {

  constructor(private topicService: TopicService, @Inject(LOCALE_ID) private localeId: string) { }

  resolve(route: ActivatedRouteSnapshot): Observable<Subject> {
    const slug = route.params['subject-slug'];
    return this.topicService.getSubjectByLocale(slug, this.localeId);
  }
}